const VARIANTS = {
  active: { bg: "var(--accent-dim)", color: "var(--accent)" },
  complete: { bg: "var(--healthy-dim)", color: "var(--healthy)" },
  paused: { bg: "var(--warning-dim)", color: "var(--warning)" },
  archived: { bg: "var(--border)", color: "var(--text-secondary)" },
  critical: { bg: "var(--critical-dim)", color: "var(--critical)" },
  warning: { bg: "var(--warning-dim)", color: "var(--warning)" },
  owner: { bg: "var(--warning-dim)", color: "var(--warning)" },
  healthy: { bg: "var(--healthy-dim)", color: "var(--healthy)" },
  info: { bg: "rgba(83, 82, 237, 0.12)", color: "var(--info)" },
};

export default function Badge({ variant = "info", children }) {
  const v = VARIANTS[variant] || VARIANTS.info;
  return (
    <span
      style={{
        display: "inline-block",
        padding: "3px 8px",
        borderRadius: "999px",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        background: v.bg,
        color: v.color,
      }}
    >
      {children}
    </span>
  );
}
